// extracted by mini-css-extract-plugin
export default {"table":"Details_table__3lpkH"};